import { render } from "./AppMenu.vue?vue&type=template&id=6497ebc9&scoped=true"
import script from "./AppMenu.vue?vue&type=script&lang=js"
export * from "./AppMenu.vue?vue&type=script&lang=js"

import "./AppMenu.vue?vue&type=style&index=0&id=6497ebc9&scoped=true&lang=scss"

import exportComponent from "/var/www/gl_frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6497ebc9"]])

export default __exports__